import { createFileRoute, Outlet } from "@tanstack/react-router";
import AdminDashboardLayout from "@/app/admin/[id]/layout";

export const Route = createFileRoute("/admin/$id")({
  component: () => (
    <AdminDashboardLayout>
      <Outlet />
    </AdminDashboardLayout>
  ),
});
